import {SurveySectionsRenderingModel, SurveySectionRenderingComponent} from "data/models/survey/base";
import React, {Fragment} from "react";
import {Paragraph} from "data/models/shared/bc-sheet/key-messages";

export type TitleComponentProps = {
  title: SurveySectionRenderingComponent,
  surveySectionRenderingModel: SurveySectionsRenderingModel | null,
  defaultTitleClass: string
}

export type DefaultTitleProps = {
  title: string, className: string
}
export const DefaultTitle = ({title, className}: DefaultTitleProps) => <span className={className}>{title}</span>;

export const EmptyTitle = <></>;

export function TitleComponent(
    {
      title,
      surveySectionRenderingModel,
    defaultTitleClass
}: TitleComponentProps
) {
  if (React.isValidElement<React.JSX.Element>(title)) {
    return title;
  }
  if (typeof title === "string") {
    return <DefaultTitle title={title} className={defaultTitleClass} />;
  }
  if (surveySectionRenderingModel === null) {
    return EmptyTitle;
  }
  return title(surveySectionRenderingModel);
}

export type ParagraphComponentProps = {
  paragraph: Paragraph,
  className?: string,
  businessName?: string,
}

type LineComponentProps = {
  line: string
}

function LineComponent({line}: LineComponentProps) {
  const strongSplit = line.split("<strong>");
  return <>
  {strongSplit[0]}
  {strongSplit.slice(1).map((text, index) => {
    const strongEndSplit = text.split("</strong>");
    if (strongEndSplit.length !== 2) {
      throw new Error(`Invalid paragraph line format: ${line}`);
    }
    return <Fragment key={index}><strong>{strongEndSplit[0]}</strong>{strongEndSplit[1]}</Fragment>;
  })}
  </>;
}

export function ParagraphComponent({paragraph, className, businessName}: ParagraphComponentProps) {
  return <p className={className}>
    {paragraph.lines.slice(0, -1).map(line => line.replaceAll("{business-name}", businessName ?? "")).map((line, index) => <Fragment key={index}><LineComponent line={line} /><br/></Fragment>)}
    {paragraph.lines.length !== 0 && <LineComponent line={paragraph.lines[paragraph.lines.length - 1].replaceAll("{business-name}", businessName ?? "")} />}
  </p>;
}
